<template>
  <v-list-item>
    <v-list-item-avatar>
      <v-icon>mdi-book-open-page-variant</v-icon>
    </v-list-item-avatar>

    <v-list-item-content class="resp-fix">
      <v-list-item-title>{{ course.name }}</v-list-item-title>
    </v-list-item-content>

    <v-list-item-action v-if="started && course.isExecuteable">
      <v-dialog v-if="course.state === 0" v-model="dialog.value" persistent max-width="350">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">
            <v-icon left>mdi-presentation-play</v-icon>
            Rozpocznij szkolenie
          </v-btn>
        </template>
        <v-card>
          <v-toolbar color="info" dark flat>
            <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-4">
            <p>Czy na pewno chcesz rozpocząć szkolenie?</p>
            <p>Twój postęp będzie zapisany.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text :disabled="dialog.loading" @click="dialog.value = false">Nie</v-btn>
            <v-btn color="primary" text :loading="dialog.loading" @click="startCourse">Tak</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn v-else color="success" dark :loading="dialog.loading" @click="startCourse">
        <v-icon left>mdi-presentation-play</v-icon>
        Kontynuuj szkolenie
      </v-btn>
    </v-list-item-action>

    <v-list-item-action v-else-if="!done">
      <span class="font-italic"
        >Szkolenie rozpocznie się <strong>{{ startDate | meetingDate }}</strong></span
      >
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as moment from 'moment';

const { mapActions } = createNamespacedHelpers('courseExecution');

export default {
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      }
    };
  },
  computed: {
    startDate() {
      if (!this.course.dateFrom) {
        return moment().add(-1, 'days');
      }

      return moment(this.course.dateFrom);
    },
    endDate() {
      if (!this.course.dateTo) {
        return null;
      }

      return moment(this.course.dateFrom);
    },
    started() {
      const now = moment();
      return this.startDate.isBefore(now);
    },
    done() {
      if (this.endDate) {
        const now = moment();
        return this.endDate.isBefore(now);
      }

      return false;
    }
  },
  methods: {
    ...mapActions(['startCourseToExecute', 'getCourseToExecute']),
    async startCourse() {
      let result;
      if (this.course.state === 0) {
        result = await this.startCourseToExecute({
          courseId: this.course.id
        });
      } else {
        result = await this.getCourseToExecute({
          courseId: this.course.id
        });
      }
      if (!result) {
        try {
          this.dialog.value = false;
          await this.$router.push('/');
        } catch (e) {
          // ignore error
        }
      } else {
        await this.$router.push(`/course/${this.course.id}`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.resp-fix {
  max-width: 100px;
}

@for $i from 18 through 26 {
  @media (min-width: #{$i * 50}px) {
    .resp-fix {
      max-width: #{($i * 50) - 600}px;
    }
  }
}

@media (min-width: 1370px) {
  .resp-fix {
    max-width: 100%;
  }
}
</style>
